import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from 'react-i18next';

import './Header.css';

const Header = ({ headerData, isAdminLoggedIn, onLogout }) => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const togleMenu = () => {
    setMenuOpen((prev) => !prev);
  }

  // Отслеживание скролла с оптимизацией
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const scrolled = scrollTop > 50;
          setIsScrolled(scrolled);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`header ${isScrolled ? 'scrolled' : ''}`}
    >
      <div className="logo-container">
        <Link to="/">
          {headerData?.logo?.logo_url ? (
            <img
              src={headerData.logo.logo_url}
              alt="Logotip"
              className="logo"
            />
          ) : (
            <p>{t('messages.loading')}</p>
          )}
        </Link>
      </div>

      <div
        className={`nav-container ${menuOpen ? 'open' : ''}`}
      >
        <nav>
          <ul
            className="nav-list"
          >
            {headerData?.menu?.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.menu_link}
                >
                  {item.menu_title}
                </Link>
              </li>
            ))}
            {isAdminLoggedIn && (
              <>
                <li>
                  <Link
                    to="/admin/panel"
                    onClick={togleMenu}
                  >
                    {t('header.adminPanel')}
                  </Link>
                </li>
                <li>
                  <button
                    onClick={() => { onLogout(); togleMenu(); }}
                    className="logout-button"
                  >
                    {t('header.logoutButton')}
                  </button>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>

      {/* Универсальное место для переключателя и бургера */}
      <div className="header-tools">
        <div className="burger" onClick={togleMenu}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
        <LanguageSwitcher />
      </div>
    </header>
  );
};

export default Header;